<div tabindex="0" (blur)="onTouched()" class="multiselect-dropdown" (clickOutside)="closeDropdown()">
  <div [class.disabled]="disabled">
    <span tabindex="-1" class="dropdown-btn"  (click)="toggleDropdown($event)">
      <span *ngIf="!selectedItems || (selectedItems?.length == 0 )">{{_placeholder}}</span>
      <ng-container *ngIf="selectedItems && !_settings.singleOutput">
        <span *ngFor="let item of selectedItems; trackBy: trackByFn;let k = index" class="selected-item-container" >
          <span class="selected-item" *ngIf="item"  [hidden]="k  > (this._settings.itemsShowLimit-1)">
            <span >{{item ? item[this._settings?.textField ?? 'label'] : ''}}&nbsp;</span>
            <a style="padding-left:2px;color:white" (click)="onItemClick($event,item)">x</a>
          </span>
        </span>
      </ng-container>
      <ng-container *ngIf="selectedItems && (selectedItems[this._settings?.textField ?? 'label'] || selectedItems['label']) && _settings.singleOutput ">
        <span  class="selected-item-container" >
          <span class="selected-item"  >
            <span >{{selectedItems && (selectedItems[this._settings?.textField ?? 'label'] || selectedItems['label']) ? selectedItems[this._settings?.textField ?? 'label'] ?? selectedItems['label'] : ''}}&nbsp;</span>
            <a style="padding-left:2px;color:white" (click)="onItemClick($event,selectedItems)">x</a>
          </span>
        </span>
      </ng-container>
      <span [ngClass]="{ 'dropdown-multiselect--active': _settings.defaultOpen }" style="float:right !important;padding-right:4px">
        <!--<span style="padding-right: 15px;" *ngIf="itemShowRemaining()>0">+{{itemShowRemaining()}}</span>-->
        <span class="dropdown-multiselect__caret"></span>
      </span>
    </span>
  </div>
  <div class="dropdown-list" [hidden]="!_settings.defaultOpen">
    <ul class="item1">
      <li (click)="toggleSelectAll()" *ngIf="(_data.length > 0 || _settings.allowRemoteDataSearch) && !_settings.singleSelection && _settings.enableCheckAll && _settings.limitSelection===-1" class="multiselect-item-checkbox" style="border-bottom: 1px solid #ccc;padding:10px">
        <input type="checkbox" aria-label="multiselect-select-all" [checked]="isAllItemsSelected()" [disabled]="disabled || isLimitSelectionReached()" />
        <div>{{!isAllItemsSelected() ? _settings.selectAllText : _settings.unSelectAllText}}</div>
      </li>
      <li class="filter-textbox" *ngIf="_settings.defaultOpen && (_data.length>0 || _settings.allowRemoteDataSearch) && _settings.allowSearchFilter">
        <input type="text" ngAutoFocus (keyup.enter)="SelectFirst()" aria-label="multiselect-search" [readOnly]="disabled"  [placeholder]="_settings.searchPlaceholderText" [(ngModel)]="filter[this._settings?.textField ?? 'label']" (ngModelChange)="onFilterTextChange($event)">
      </li>
    </ul>
    <ul class="item2" #scrollContainer [style.maxHeight]="_settings.maxHeight+'px'">
      <div class="p-2">
        <button *ngIf="_settings?.idImage && page - 1 != 0" (click)="onPageUp($event)" class="btn btn-outline-dark w-100 py-2 px-3 d-flex align-items-center justify-content-center gap-2 rounded shadow-sm text-uppercase fw-semibold"><i class="bi bi-arrow-up-circle"></i> Torna Indietro</button>      
      </div>
      <li (click)="onItemClick($event,item)" *ngFor="let item of _data | multiSelectFilter: filter : _settings; let i = index;"
          class="multiselect-item-checkbox">
        <input type="checkbox" [attr.aria-label]="item[_settings?.textField ?? 'label']" [checked]="isSelected(item)" [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item)) || item[this._settings?.disabledField ?? 'isDisabled']" />
        <div class="d-flex align-items-start gap-2">
          <img
            [src]="getImageLink(item[_settings?.idImage])"
            width="100px"
            height="auto"
            alt="No Image"
            *ngIf="item[_settings?.idImage]"
          />
          <div [ngClass]="{'d-flex flex-column': item[_settings?.idImage]}">
            <div
              [ngClass]="{
                'fw-bold': item[_settings?.idImage],
                'text-uppercase': item[_settings?.idImage],
                'fs-3': item[_settings?.idImage],
                'pl-2': item[_settings?.idImage]

              }"
            >
              {{ item[_settings?.textField ?? 'label'] }}
            </div>
            <div
              *ngIf="_settings?.subtitleField && item[_settings?.subtitleField]"
              [ngClass]="{
                'text-muted': true,
                'fs-6': true,
                'pl-2': item[_settings?.subtitleField]
              }"
            >
              {{ item[_settings?.subtitleField] }}
            </div>
          </div>
        </div>
      </li>
      <div class="p-2">
        <button *ngIf="_settings?.idImage && page < totalPages" (click)="onPageDown($event)" class="btn btn-outline-dark w-100 py-2 px-3 d-flex align-items-center justify-content-center gap-2 rounded shadow-sm text-uppercase fw-semibold"
        >Mostra Altro <i class="bi bi-arrow-down-circle"></i></button>      
      </div>
      <li class='no-filtered-data' *ngIf="_data.length != 0 && (_data | multiSelectFilter:filter : _settings).length == 0 && !_settings.allowRemoteDataSearch">
        <h6>{{_settings.noFilteredDataAvailablePlaceholderText}}</h6>
        <button class="btn btn-outline-primary" *ngIf="this._settings.moreButton" (click)="onMoreButtonClick.emit(filter)">{{this._settings.moreButtonText ?? 'More'}}</button>
      </li>
      <li class='no-data' *ngIf="_data.length == 0">
        <h6>{{_settings.noDataAvailablePlaceholderText}}</h6>
        <button class="btn btn-outline-primary" *ngIf="this._settings.moreButton" (click)="onMoreButtonClick.emit(filter)">{{this._settings.moreButtonText ?? 'More'}}</button>
      </li>
    </ul>
  </div>
</div>
